import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { FetchManagerListParams } from '@module/apis/client-side/manager/type';

export const managerQueryKeys = createQueryKeys('manager', {
  fetchManagerList: (params: FetchManagerListParams) => [params],
  postCancelManager: () => ['postCancelManager'],
  postWriteManager: () => ['postWriteManager'],
});
